module.exports = __webpack_public_path__ + "static/media/certificateNew.08015af7.png";